<template>
  <v-col class="fill-height product-info">
    <div
      v-if="loading"
    >
      <v-skeleton-loader
        type="article"
        elevation="0"
      ></v-skeleton-loader>
      <v-skeleton-loader
        type="actions"
        elevation="0"
      ></v-skeleton-loader>
    </div>
    <div
      v-if="!loading && auction && auction.starts_at && pagination && pagination.total"
    >
      <div class="product-info__top">
        <div class="mb-3 d-flex flex-row align-content-space-between product-info">
          <Button
            v-if="loteId > 1"
            background-color="#ffffff"
            border-color="#ee396c"
            font-color="#ee396c"
            @click="prevLote"
          >
            <v-icon>
              keyboard_arrow_left
            </v-icon>
            Voltar Lote
          </Button>
          <v-spacer></v-spacer>
          <Button
            background-color="#ffffff"
            border-color="#ee396c"
            font-color="#ee396c"
            @click="nextLote"
            v-if="loteId < pagination.total"
          >
            Próximo Lote
            <v-icon>
              keyboard_arrow_right
            </v-icon>
          </Button>
        </div>
        <Heading
          font-weight="bold"
          font-size="24px"
          line-height="36px"
          letter-spacing="-0.015em"
          color="#000000;"
          class="mb-4"
        >
          {{ lot.name }}
        </Heading>
        <Heading
          font-size="14px"
          line-height="22px"
          letter-spacing="-0.015em"
          color="#000000"
          level="2"
          class="text-justify mb-2"
          v-if="lot.artist"
        >
          {{ lot.artist.name }}
        </Heading>
        <Countdown :is-pre="countdownIsPre" />
        <p class="text-justify mt-4">
          {{ lot.description }}
        </p>
      </div>
      <v-row class="product-info__bids">
        <v-col class="my-0 py-0">
          <Heading
            font-weight="bold"
            font-size="24px"
            line-height="36px"
            letter-spacing="-0.015em"
            color="#000000;"
            level="2"
            class="mb-2"
          >
            Lances
          </Heading>
          <div class="product-info__price">
            <span class="prefix">Valor Atual:</span>
            <span class="price">{{ amount | currency }}</span>
          </div>
          <Heading
            font-weight="bold"
            font-size="24px"
            line-height="36px"
            letter-spacing="-0.015em"
            color="#000000;"
            level="2"
            class="mb-4"
          >
            Meu Lance
          </Heading>
          <input
            v-model="amountInput"
            v-currency="{ currency: 'BRL', locale: 'pt-br' }"
            required
            hide-details
            class="product-info__input"
          />
          <div class="product-info__buttons">
            <Button @click="sendBind(amountInput)">
              Realizar Lance
            </Button>
            <Button
              background-color="#ffffff"
              border-color="#ee396c"
              font-color="#ee396c"
              class="ml-3"
              @click="sendBindAuto(1000)"
            >
              + R$ 1.000
            </Button>
          </div>
        </v-col>
        <v-col
          class="my-0 py-0"
          style="border-left: 1px solid rgb(245, 245, 245)"
        >
          <v-card-title class="mb-0">
            Histórico de Lances ({{ bids.length }})
          </v-card-title>
          <v-card-text>
            <v-virtual-scroll
              :items="bids"
              :item-height="50"
              height="200"
              bench="2"
            >
              <template v-slot:default="{ item }">
                <v-list-item class="ma-0 pa-0 pr-2">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.user || 'User' }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>
                      {{ item.amount | currency }}
                      <br /><small>{{ item.date | now }}</small>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-card-text>
        </v-col>
      </v-row>
    </div>
  </v-col>
</template>

<script>
import Heading from '@/components/Heading/Heading.vue';
import Countdown from '@/views/leilao/components/Countdown';
import Button from '@/components/Button/Button.vue';
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';
import BidsService from '@/services/BidsService';

export default {
  name: 'Bids',
  components: {
    Heading,
    Countdown,
    Button,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    countdownIsPre: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      user: null,
      amount: 3000,
      amountInput: 0,
    };
  },
  computed: {
    loteId() {
      return this.$route.params.lote;
    },
    ...mapState('Data/Auctions', [
      'auction',
      'lot',
      'bids',
      'pagination',
    ]),
  },
  mounted() {
    this.user = this.bids[
      Object.keys(this.bids)[Math.floor(Math.random() * Object.keys(this.bids).length)]
    ];
    // console.log('socket io', this.sockets);
    if (this.sockets) {
      this.sockets.subscribe('bid', (data) => {
        BidsService.addBids(data);
        this.amount = data.value;
        // console.log('receive', data);
      });
    }
  },
  methods: {
    ...mapMutations('Data/Auctions', [
      'setPage',
    ]),
    prevLote() {
      this.$route.params.lote--;
      this.setPage(this.$route.params.lote);
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
      });
    },
    nextLote() {
      this.$route.params.lote++;
      this.setPage(this.$route.params.lote);
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
      });
    },
    sendBind(amount) {
      amount = amount
        .replace(/\./g, '')
        .replace(/,/g, '.')
        .replace('R$ ', '');
      // console.log(amount);
      this.amount = +amount;
      const payload = {
        _id: this.user.id,
        name: this.user.name,
        value: this.amount,
        date: moment(),
      };
      this.$socket.emit('bid', payload);
    },
    sendBindAuto(sum) {
      this.amount += +sum;
      const payload = {
        _id: this.user.id,
        name: this.user.name,
        value: this.amount,
        date: moment(),
      };
      this.$socket.emit('bid', payload);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.product-info {
  &__input {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.5);
    padding: 8px 16px;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: -0.015em;
    color: rgba(0, 0, 0, 0.8);
    width: 100%;
  }

  &__top {
    margin: 0 25px;
  }

  &__bids {
    padding: 0 25px;
    @media (max-width: $xl) {
      display: flex;
      flex-direction: column;
    }
  }
  &__buttons {
    margin-top: 25px;
    @media (max-width: $lg) {
      width: 100%;
      display: flex;
    }
  }
  &__price {
    letter-spacing: -0.015em;
    color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;

    .prefix {
      font-size: 18px;
      margin-right: 10px;
    }
    .price {
      font-size: 36px;
      @media (max-width: $xxl) {
        font-size: 22px;
      }
    }
  }
  &__social {
    margin: 0 25px;
  }
}
</style>
